const compound = {
    title: 'Compounds',
    seeList: 'see list view',
    tableHeader: {
        compound: 'Compound',
        drivers: 'Drivers',
        targets: 'Targets',
        gds: 'GDS'
    },
    noCompoundsFound: 'No compounds were found for this patient.',
    generalErrors: {
        unknown: {
            title: 'Something went wrong',
            description: 'Compounds could not be loaded from the server.'
        },
        accessDenied: {
            title: 'Access Denied',
            description: 'You have no permission to view compounds.'
        }
    }
}

export default compound
